import { ref, defineComponent, watchEffect, computed } from 'vue';
import classNames from '../_util/classNames';
import PropTypes from '../_util/vue-types';
import CloseOutlined from '@ant-design/icons-vue/CloseOutlined';
import Wave from '../_util/wave';
import CheckableTag from './CheckableTag';
import MarketIcon from './svg';
import useConfigInject from '../_util/hooks/useConfigInject';
import { RegionTypeEnum } from '../_util/enum';
// const PresetColorRegex = new RegExp(`^(${PresetColorTypes.join('|')})(-inverse)?$`);
// const PresetStatusColorRegex = new RegExp(`^(${PresetStatusColorTypes.join('|')})$`);
export const tagProps = () => ({
    prefixCls: String,
    color: {
        type: String,
    },
    closable: { type: Boolean, default: false },
    closeIcon: PropTypes.any,
    visible: { type: Boolean, default: undefined },
    onClose: {
        type: Function,
    },
    'onUpdate:visible': Function,
    icon: PropTypes.any,
    regionType: {
        type: Number,
    },
    regionTypeSize: { type: String },
    backgroundColor: String,
    bordered: {
        type: [String, Boolean],
        default: false,
    },
    popover: {
        type: Boolean,
        default: false,
    },
    underline: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: 'long',
    },
});
const Tag = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdTag',
    props: tagProps(),
    // emits: ['update:visible', 'close'],
    slots: ['closeIcon', 'icon'],
    setup(props, { slots, emit, attrs }) {
        const { prefixCls, direction } = useConfigInject('tag', props);
        const visible = ref(true);
        watchEffect(() => {
            if (props.visible !== undefined) {
                visible.value = props.visible;
            }
        });
        const handleCloseClick = (e) => {
            e.stopPropagation();
            emit('update:visible', false);
            emit('close', e);
            if (e.defaultPrevented) {
                return;
            }
            if (props.visible === undefined) {
                visible.value = false;
            }
        };
        // const isPresetColor = computed(() => {
        //   const { color } = props;
        //   if (!color) {
        //     return false;
        //   }
        //   return PresetColorRegex.test(color) || PresetStatusColorRegex.test(color);
        // });
        const tagClassName = computed(() => classNames(prefixCls.value, {
            // [`${prefixCls.value}-${props.color}`]: isPresetColor.value,
            // [`${prefixCls.value}-has-color`]: props.color && !isPresetColor.value,
            [`${prefixCls.value}-hidden`]: !visible.value,
            [`${prefixCls.value}-rtl`]: direction.value === 'rtl',
            [`${prefixCls.value}-popover`]: props.popover,
        }));
        return () => {
            const { icon = slots.icon?.(), color, closeIcon = slots.closeIcon?.(), closable = false, regionType, backgroundColor, bordered, regionTypeSize, underline, } = props;
            const renderCloseIcon = () => {
                if (closable) {
                    return closeIcon ? (<span class={`${prefixCls.value}-close-icon`} onClick={handleCloseClick}>
              {closeIcon}
            </span>) : (<CloseOutlined class={`${prefixCls.value}-close-icon`} onClick={handleCloseClick}/>);
                }
                return null;
            };
            const borderStyle = () => {
                if (typeof bordered === 'boolean') {
                    if (bordered) {
                        return {
                            'border-radius': '4px',
                            border: `1px solid`,
                        };
                    }
                }
                if (typeof bordered === 'string') {
                    return {
                        'border-radius': '4px',
                        border: `1px solid ${bordered}`,
                    };
                }
            };
            const tagStyle = {
                backgroundColor: props.regionType === RegionTypeEnum.HK
                    ? 'var(--wd-charts-violet-light)'
                    : props.regionType === RegionTypeEnum.US
                        ? 'var(--wd-charts-dorger-light)'
                        : backgroundColor,
                color,
                // backgroundColor: color && !isPresetColor.value ? color : undefined,
            };
            const isMarketIcon = props.regionType !== undefined && props.regionType !== null;
            const marketIconNode = isMarketIcon ? (<MarketIcon regionType={regionType} size={regionTypeSize}/>) : null;
            const iconNode = isMarketIcon ? marketIconNode : icon || null;
            const children = slots.default?.();
            let Component = 'span'; // 大写时能够识别出为动态标签
            if (underline)
                Component = 'u';
            let kids;
            if (iconNode) {
                kids = (<>
            {iconNode}
            <Component>{children}</Component>
          </>);
            }
            else {
                if (props.popover) {
                    kids = <Component>{children}</Component>;
                }
                else {
                    kids = (<>
              <Component>{children}</Component>
            </>);
                }
            }
            const isNeedWave = 'onClick' in attrs;
            const tagNode = (<span class={classNames(tagClassName.value, {
                    [`${tagClassName.value}-region-type`]: props.regionType !== undefined,
                    [`${tagClassName.value}-region-type-${props.regionTypeSize}`]: props.regionType !== undefined && props.regionTypeSize,
                    [`${tagClassName.value}-short`]: props.type === 'short',
                })} style={{ ...tagStyle, ...borderStyle() }}>
          {kids}
          {renderCloseIcon()}
        </span>);
            return isNeedWave ? <Wave>{tagNode}</Wave> : tagNode;
        };
    },
});
Tag.CheckableTag = CheckableTag;
Tag.install = function (app) {
    app.component(Tag.name, Tag);
    app.component(CheckableTag.name, CheckableTag);
    return app;
};
export { CheckableTag };
export default Tag;
